const SCHEMA_TOKEN = 'quirons-token'
const SCHEMA_PERSIST = 'quirons-persist'
const SCHEMA_IDENTIFIER = 'quirons-identifier'

export const isCachePersisted = () =>
    localStorage.getItem(SCHEMA_PERSIST) === 'true'

export const setCachePersistence = (persist: boolean) => {
    localStorage.setItem(SCHEMA_TOKEN, '')
    sessionStorage.setItem(SCHEMA_TOKEN, '')

    localStorage.setItem(SCHEMA_PERSIST, persist.toString())
}

export const getAuthToken = () => {
    const persist = isCachePersisted()

    if (persist) {
        return localStorage.getItem(SCHEMA_TOKEN)
    }

    return sessionStorage.getItem(SCHEMA_TOKEN)
}

export const setAuthToken = (token: string) => {
    const persist = isCachePersisted()

    if (persist) {
        localStorage.setItem(SCHEMA_TOKEN, token)

        return
    }

    sessionStorage.setItem(SCHEMA_TOKEN, token)
}

export const removeAuthToken = () => {
    sessionStorage.removeItem(SCHEMA_TOKEN)
    localStorage.removeItem(SCHEMA_TOKEN)
    localStorage.removeItem(SCHEMA_PERSIST)
}

export const setLoginIdentifier = (identifier: string | null) => {
    if (identifier) {
        localStorage.setItem(SCHEMA_IDENTIFIER, identifier)

        return
    }

    localStorage.removeItem(SCHEMA_IDENTIFIER)
}

export const getLogoutPath = () => {
    const identifier = localStorage.getItem(SCHEMA_IDENTIFIER)

    return identifier
        ? `/login?${new URLSearchParams({ identifier })}`
        : '/login'
}
